"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLightbulbOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M14.336 15a8.33 8.33 0 01.23-.505c.137-.277.294-.564.51-.942.05-.085.437-.754.55-.954C16.575 10.93 17 9.776 17 8.5 17 5.852 14.771 4 11.997 4S7 5.85 7 8.5c0 1.275.422 2.415 1.369 4.078.108.19.484.837.55.952.215.376.372.665.51.945.089.181.168.356.237.525h4.67zm-.348 2h-3.983c.05 2.365.512 2.99 1.992 2.99 1.489 0 1.942-.606 1.991-2.99zM19 8.5c0 1.705-.53 3.141-1.634 5.086-1.333 2.348-1.373 2.43-1.373 2.937 0 3.742-1.035 5.468-3.996 5.468C9.043 21.99 8 20.243 8 16.523c0-.532-.065-.664-1.369-2.955C5.526 11.628 5 10.206 5 8.5 5 4.655 8.192 2 11.997 2 15.803 2 19 4.658 19 8.5zM15.003 10C14.006 10 14 9 14 9c0-1.125-.92-2.001-2.002-2.001 0 0-.999 0-.999-.999s1-1 1-1a4 4 0 014 4s0 1-.997 1h.001z' }))); };
exports.default = SvgLightbulbOutline;
//# sourceMappingURL=LightbulbOutline.js.map